<template>
    <div>
        <regions-modal></regions-modal>
        <component :is="availableQuestions[currentQuestion]" v-bind="{division: dynamic.keys.division}" @skip="incrementQuestion"></component>
        <TrustpilotMicroCombo/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PreviousButton from './PreviousButton.vue';
import NextButton from './NextButton.vue';
import LeadFooter from './LeadFooter.vue';
import LeadHeader from "./LeadHeader.vue";
import StepQualifierTenantLandlord from "./QualifyingQuestions/StepQualifierTenantLandlord.vue";
import StepQualifierTraffic from "./QualifyingQuestions/StepQualifierTraffic.vue";
import {set} from "lodash";
import StepQualifierEstate from "./QualifyingQuestions/StepQualifierEstate.vue";
import TrustpilotMicroCombo from "./TrustpilotMicroCombo.vue";

export default {
    components: {
        StepQualifierTenantLandlord,
        StepQualifierTraffic,
        StepQualifierEstate,
        PreviousButton,
        NextButton,
        LeadHeader,
        LeadFooter,
        TrustpilotMicroCombo
    },
    computed: {
        ...mapGetters('lead', [
            'form',
        ]),
    },
    props: {
        dynamic: {
            type: Object,
            required: true,
        }
    },
    data: () => ({
        availableQuestions: [
            StepQualifierEstate,
            StepQualifierTenantLandlord,
            StepQualifierTraffic
        ],
        currentQuestion: 0,
    }),
    methods: {
        incrementQuestion() {
            this.currentQuestion++;
            if (this.currentQuestion === this.availableQuestions.length) {
                let form = JSON.parse(window.localStorage.getItem('lcsForm'));
                set(form, 'has_qualifying_question', false);
                window.localStorage.setItem('lcsForm', JSON.stringify(form));
                this.$event.$emit('step:next');
            }
        },
    },
    mounted() {
        window.dataLayer.push({
            event: 'form_step_mounted',
            form_step_id: window.getCurrentStep(),
            form_step_name: 'qualify'
        });
    }
};
</script>
